<template>
	<BaseWebshopCouponForm v-slot="{onSubmit, onRemove, couponCode, message, error, loading, activeCoupon, handleInput}" :mode="props.mode">
		<div class="base-coupon" :class="[{'base-coupon-checkout': mode == 'checkout'},{'base-coupon-auth': mode == 'auth'},{'base-coupon-cart': mode == 'webshop'},{'base-coupon-error': error}, {'base-coupon-active': activeCoupon}, {'loading': loading}]">
			<BaseCmsLabel code="coupon_label" tag="div" class="coupon-label" v-if="mode == 'webshop' && !activeCoupon?.code" />
			<form v-if="mode == 'webshop' || mode == 'checkout'" class="base-coupons-form" :class="{'input-focused': isFocused && !activeCoupon?.code}" @submit.prevent="couponCode && !activeCoupon && onSubmit()">
				<input
					class="base-coupons-input"
					:readonly="activeCoupon?.code"
					:placeholder="activeCoupon?.code ? labels.get('coupon_active').replace('%VALUE%', activeCoupon.code) : labels.get('coupon_code')"
					type="text"
					:value="couponCode"
					name="coupon"
					@keyup="handleInput"
					@focus="isFocused = true"
					@blur="isFocused = false"
					v-if="!activeCoupon?.code" />
				<div class="base-coupons-input base-coupons-div" v-if="activeCoupon?.code" v-html="labels.get('coupon_active').replace('%VALUE%', activeCoupon?.code)"></div>
				<button v-if="!activeCoupon" class="base-coupons-btn base-coupons-btn-add" type="submit" :class="{'disabled': !couponCode}" :disabled="!couponCode"><BaseCmsLabel code="coupon_add" /></button>
				<button v-if="activeCoupon" class="base-coupons-btn base-coupons-btn-remove" :class="{'disabled': couponCode && !activeCoupon}" type="button" @click="onRemove"><BaseCmsLabel code="coupon_remove" /></button>
				<BaseCmsLabel v-if="message" class="base-coupons-status" tag="div" :code="message" />
				
				<BaseAuthCoupons v-if="auth.isLoggedIn()" v-slot="{items, onActivate, status}">
					<div v-if="!activeCoupon && items?.length" class="ww-coupons-table-cnt">
						<div class="ww-coupons-table-title"><BaseCmsLabel code="coupon_available" /></div>
						<div class="ww-coupons-table">
							<div class="ww-coupons-table-row" v-for="item in items" :key="item.id">
								<div class="col-code">{{item.code}}</div>
								<div class="col-type">
									<span v-if="item.type == 'f'"><BaseUtilsFormatCurrency :price="item.coupon_price" /></span>
									<span v-else>-{{ item.coupon_percent * 100 }}%</span>
								</div>
								<div class="col-link">
									<span class="btn-coupon-add" @click="onActivate(item.code)"><BaseCmsLabel code="coupon_use" /></span>
								</div>
							</div>
						</div>
					</div>
					<BaseCmsLabel v-if="status" class="base-coupons-status" tag="div" :code="status.label_name" />
				</BaseAuthCoupons>
			</form>
			<form v-else class="base-coupons-form base-coupon-form-auth" @submit.prevent="onSubmit()">
				<input 
					class="base-coupons-input" 
					:placeholder="labels.get('new_coupon')" 
					type="text" 
					name="coupon" 
					:value="couponCode" 
					@keyup="handleInput"
					@focus="isFocused = true"
					@blur="isFocused = false" />
				<button v-if="!activeCoupon" class="base-coupons-btn base-coupons-btn-add base-coupons-btn-add-auth" type="submit" :class="{'disabled': !couponCode}" :disabled="!couponCode"><BaseCmsLabel code="coupon_add" /></button>
				<button v-if="isFocused" class="base-coupons-btn base-coupons-btn-focused" :class="{'disabled': couponCode && !activeCoupon}" type="button" @click="onRemove"><BaseCmsLabel code="coupon_remove" /></button>
				<BaseCmsLabel v-if="message" class="base-coupons-status" tag="div" :code="message" />
			</form>
		</div>
	</BaseWebshopCouponForm>
</template>

<script setup>
	const props = defineProps(['mode']);
	const labels = useLabels();
	const auth = useAuth();
	const isFocused = ref(false);
</script>

<style lang="less" scoped>
	.base-coupon{
		position: relative; display: flex; flex-flow: column; margin-bottom: 32px;
		@media (max-width: @m){margin-bottom: 24px;}
	}
	.coupon-label{
		display: block; font-size: 14px; line-height: 1.2; margin-bottom: 15px; font-weight: 700;
		@media (max-width: @m){margin-bottom: 12px;}	
	}
	.base-coupons-form{
		position: relative; display: block;
		&:before{.pseudo(22px,15px); .icon-coupon(); font: 15px/1 var(--fonti); color: var(--blue); top: 19px; left: 20px; z-index: 1;}
		@media (max-width: @m){
			&:before{top: 21px; left: 16px;}
		}
	}
	.base-coupons-input{
		padding-left: 53px;
		@media (max-width: @m){padding-left: 49px;}	
	}
	.base-coupons-btn{
		position: absolute; top: 3px; right: 3px; padding-top: 0; padding-bottom: 0; height: 50px;
		&.disabled{display: none;}
		@media (max-width: @m){width: auto; top: 4px;}
	}
	.base-coupons-status{
		font-size: 11px; padding: 5px 0 0 53px; position: absolute; top: 53px;
		@media (max-width: @m){padding-left: 49px; top: 56px;}	
	}

	.base-coupon-checkout{
		padding: 20px 24px; margin-bottom: 0;
		@media (max-width: @m){padding: 16px 16px 18px;}	
	}

	.base-coupon-active{
		.base-coupons-form{
			display: flex;
			&:before{display: none;}
		}
		.base-coupons-input{padding-left: 0; flex-grow: 1; flex-shrink: 1;}
		.base-coupons-btn-remove{
			background: transparent; padding: 0; color: var(--red); height: unset; position: relative; top: auto; right: auto; text-decoration: underline; .transition(text-decoration-color);
			&:after{display: none;}	
			@media (min-width: @h){
				&:hover{text-decoration-color: transparent;}
			}
		}
		.base-coupons-status{top: 18px; padding-left: 0;}
	}
	.base-coupons-btn-focused{
		background: transparent; padding: 0; font-size: 0; width: 14px; height: 14px; display: flex; align-items: center; justify-content: center; right: 16px; top: 20px;
		&:before{.icon-cross(); font: 14px/1 var(--fonti); color: var(--textColor); position: absolute;}
		&:after{display: none;}
	}

	//LIST
	.ww-coupons-table-cnt{margin-top: 15px;}
	.ww-coupons-table-title{font-weight: bold; padding: 0 0 8px; font-size: 13px;}
	.ww-coupons-table{
		width: 100%;
	}
	.ww-coupons-table-row{display: flex; align-items: center; justify-content: space-between; font-size: 13px; padding: 7px 0; border-top: 1px solid #E8E9F3;}
	.col-type{text-align: center;}
	.col-link{text-align: right; font-weight: bold; cursor: pointer; color: var(--red);}


	//AUTH
	.base-coupons-btn-add-auth{
		&:after{display: none;}
	}
</style>